import React, { useState, useEffect, useCallback } from 'react'
import Modal from '../Modal'
import Button from '../Button'
import Typography from '../Typography'
import { Editor } from '@monaco-editor/react' // Import the Editor component
import { showNotification } from '../Notification'

const HtmlEditor = ({ controller }) => {
  const [content, setContent] = useState('')
  const { articlePayload } = controller

  useEffect(() => {
    if (articlePayload && articlePayload.content) {
      setContent(articlePayload.content)
    }
  }, [articlePayload])

  const handlePublish = useCallback(async () => {
    const update = {
      content,
      articleID: articlePayload.articleID,
    }
    const result = await controller.publishArticle(update)

    if (result.error) {
      showNotification({
        message: 'Failed to update source',
        className: 'bg-red-500 text-text_inv',
      })
      return
    }
    controller.refreshArticle()

    showNotification({
      message: 'Article source updated',
      className: 'bg-primary text-text_inv',
    })

    controller.setEditorOpen(false)
  }, [content])

  return (
    <Modal
      isOpen={controller.editorOpen}
      onCloseRequested={controller.setEditorOpen}
      closeOnEscape={true}
      className="w-[900px] h-[665px] bg-gray-800 text-white rounded-lg"
    >
      <div className="flex flex-col h-full">
        <div className="flex justify-center items-center gap-10">
          <Typography variant="h3" className="text-2xl font-bold mb-4">
            Article HTML
          </Typography>

          <Button
            onClick={controller.copyHTMLSource}
            variant={'viewer_controls'}
            className=" mb-5  hover:bg-blue-600 text-text font-bold py-2 px-4 rounded"
          >
            Copy Source
          </Button>
        </div>
        <div className="flex-grow overflow-hidden h-[500px]">
          <Editor
            width={'100%'}
            height={'100%'}
            language="html" // Set the language to HTML for syntax highlighting
            value={content}
            onChange={(value) => setContent(value)}
            theme="vs-dark" // Use a dark theme, you can change it as needed
            options={{
              minimap: { enabled: false }, // Hide the minimap if not needed
              scrollBeyondLastLine: false, // Disable scrolling beyond the last line
              lineNumbers: 'on', // Show line numbers
              wordWrap: 'on', // Enable word wrapping
            }}
          />
        </div>
        <Button
          onClick={handlePublish}
          className="mt-4 w-full bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded"
        >
          Update
        </Button>
      </div>
    </Modal>
  )
}

export default HtmlEditor
